module.exports = __webpack_public_path__ + "img/logo.4fcf9cbf.svg";